import { z } from "zod";
import {
  DATE_RANGE,
  SELECTION_CRITERIA,
  YEAR
} from "./consts";

export const schema = z.object({
  [SELECTION_CRITERIA]: z.string().min(1, "This field is required"),
  [DATE_RANGE]: z.object({
      from: z.date().optional().nullable(),
      to: z.date().optional().nullable(),
    }).optional(),
  [YEAR]: z.string().optional(),
})
.superRefine((data, ctx) => {
  // 1. If Monthly -> Check Date Range
  if (data[SELECTION_CRITERIA] === 'monthly') {
    if (!data[DATE_RANGE]?.from && !data[DATE_RANGE]?.to) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "This field is required",
        path: [DATE_RANGE], // Points the error to the Date Range field
      });
    }
  } else {
    if (!data[YEAR] || data[YEAR].trim() === "") {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "This field is required",
        path: [YEAR], // Points the error to the Year field
      });
    }
  }
});

export type formValues = z.infer<typeof schema>;
